<template>
    <div class="my-auto">
        <v-alert v-if="error" color="error" outlined max-width="800" class="mx-auto">
            {{ error }}
        </v-alert>
        <v-alert v-else color="primary" outlined max-width="800" class="mx-auto"> Loading... </v-alert>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            error: '',
        };
    },

    mounted() {
        const state = JSON.parse(this.$route.query.state);
        if (state.return_url) {
            const req = {
                RedirectURL: window.location.origin + this.$router.resolve({ name: 'auth/google' }).route.path,
                AuthCode: this.$route.query.code,
                ReturnURL: state.return_url,
            };
            this.loading = true;
            this.$api.authGoogle(req, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                window.location.href = state.return_url + '?t=' + data;
            });
            return;
        }
        this.$router.replace({ name: state.action, query: { ...state.params, google: this.$route.query.code } });
    },
};
</script>

<style scoped></style>
